exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-custom[data-v-6f5c2734]{font-size:14px!important;height:38px;text-align:center;padding:.375rem .5rem;border-radius:68px;min-width:280px}", ""]);

// exports
